import { AbstractControl, NgForm, ValidatorFn } from '@angular/forms';

export class Predicates {
  static isDigitsOnly(event: KeyboardEvent) {
    return /^-?[0-9]*$/.test(event.key);
  }

  static isFloatOnly(event: KeyboardEvent) {
    return /^-?[0-9]*\.[0-9]+$/.test((event.target as HTMLInputElement)?.value ?? '' + event.key);
  }

  static isSpecialChar(event: KeyboardEvent) {
    return !/^(\p{Letter}|[0-9' ])$/u.test(event.key);
  }

  static not(predicate: (event: KeyboardEvent) => boolean) {
    return (event: KeyboardEvent) => !predicate(event);
  }
}

export const keydownRestrictions =
  (...predicates: ((_: KeyboardEvent) => boolean)[]) =>
  (e: KeyboardEvent) => {
    if (e.type === 'keydown' && e.key.length === 1 && !e.ctrlKey) {
      const failed = predicates.some(p => !p(e));
      if (failed) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
  };

export class SpValidators {
  static phone: ValidatorFn = ctrl => {
    const digits = (ctrl.value as string)?.replace(/[^0-9]/g, '');
    return digits?.length > 0 && digits?.length !== 10
      ? { phone: 'Phone number must be 10 digits long' }
      : null;
  };

  /** `OnlyIf()` modifies an existing ValidatorFn such that it will only give
   * validation results if `predicate` evaluates to `true`
   */
  static onlyIf = (predicate: () => boolean, validator: ValidatorFn) => (ctrl: AbstractControl) =>
    predicate() ? validator(ctrl) : null;
}

/** Iterate through formControls contained in form and run fn(formControl) on
 *  it. forEachFormControl is similar to Array.forEach()
 */
export const forEachFormControl = (
  form: NgForm,
  fn: (c: AbstractControl, label: string, index: number) => void
) => Object.entries(form?.controls ?? {}).forEach(([label, ctrl], index) => fn(ctrl, label, index));
